import {Text} from '@rdcomponents/text/text';
import {Button, Skeleton, Switch, Tooltip} from 'antd';

import {FormattedNumber} from '../../../../../provider/locale/formatted-number';
import {Locale} from '../../../../../provider/locale/locale';
import {classNames} from '../../../../../util/css';

import {reviewsFilterFormId} from './reviews-filter-const';
import {useReviewsFilter} from './use-reviews-filter';
import * as styles from './reviews-filter.scss';

type FilterHookType = ReturnType<typeof useReviewsFilter>;

type PropsType = {
    filterHook: FilterHookType;
};

export function ReviewsFilterDrawerFooter(props: PropsType): JSX.Element {
    const {filterHook} = props;

    const {
        isSavedFilterEnabled,
        isSavedFilterLoading,
        isSavedFilterSaving,
        isReviewsStatisticFetching,
        totalReviewsLabelCount,
        handleDrawerReset,
        handleSavedFilterToggle,
        handleSavedFilterKeyDown,
    } = filterHook;

    const isSaveDisabled = isSavedFilterLoading || isSavedFilterSaving;

    return (
        <div className={styles.ReviewsFilter_drawerFooter}>
            <div className={styles.ReviewsFilter_drawerFooterActions}>
                <Button className={styles.ReviewsFilter_footerButton} onClick={handleDrawerReset}>
                    <Locale stringKey="TEXT__RESET" />
                </Button>
                <Button
                    className={styles.ReviewsFilter_drawerFooterApply}
                    form={reviewsFilterFormId}
                    htmlType="submit"
                    type="primary"
                >
                    <Locale
                        stringKey="REVIEWS__FILTER__SHOW_WITH_COUNT"
                        valueMap={{
                            count: isReviewsStatisticFetching ? (
                                <Skeleton.Input
                                    active
                                    className={styles.ReviewsFilter_applyCountSkeleton}
                                    size="small"
                                />
                            ) : (
                                <FormattedNumber value={totalReviewsLabelCount} />
                            ),
                        }}
                    />
                </Button>
            </div>
            <Tooltip title={isSavedFilterEnabled ? null : <Locale stringKey="REVIEWS__FILTER__SAVE_FILTERS_TOOLTIP" />}>
                <div
                    aria-checked={isSavedFilterEnabled}
                    aria-disabled={isSaveDisabled}
                    className={classNames(
                        styles.ReviewsFilter_saveSwitch,
                        isSaveDisabled ? styles.ReviewsFilter_saveSwitch_disabled : ''
                    )}
                    onClick={handleSavedFilterToggle}
                    onKeyDown={handleSavedFilterKeyDown}
                    role="switch"
                    tabIndex={isSaveDisabled ? -1 : 0}
                >
                    <Switch
                        checked={isSavedFilterEnabled}
                        disabled={isSaveDisabled}
                        loading={isSavedFilterSaving}
                        size="small"
                    />
                    <Text className={styles.ReviewsFilter_saveSwitchText}>
                        <Locale stringKey="REVIEWS__FILTER__SAVE_FILTERS" />
                    </Text>
                </div>
            </Tooltip>
        </div>
    );
}
